import { lazyGetReadingPaneOptionsSections } from 'owa-mail-ribbon-sections/lib/sections';

import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';

export const onReadingPaneOptionsMenuClicked = (): void => {
    lazyGetReadingPaneOptionsSections.import().then(getReadingPaneOptions => {
        setMenuDefinition(
            'ReadingPaneOptionsMenuDefinitionStore',
            undefined /* projectionTabId */,
            () => {
                return {
                    sections: getReadingPaneOptions(),
                };
            }
        );
    });
};
